import { put, takeEvery } from 'redux-saga/effects';
import http from '@/assets/api/http';
import * as T from './actiontypes';

// 获取登录时菜单
export const getMenuList = function* () {
    yield takeEvery(T.GET_MENUS_LIST, function* requestData() {
        try {
            let result = yield http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listMenus', {}, 'POST');
            yield put({ type: T.SET_MENUS_LIST, payload: result });
        } catch (e) {
            yield put({ type: 'SAGA_ERROR', payload: { error: e } });
        }
    });
};